import { API_ROUTES } from "./constants";
import axiosInstance from "./axiosInstance";

// Update an existing page
export const authLogin = async (authdata) => {
  try {
    const response = await axiosInstance.post(`${API_ROUTES.AUTH.LOGIN}`, authdata);
    return response.data;
  } catch (error) {
    console.error('Error updating page:', error);
    throw error;
  }
};